module.exports = __webpack_public_path__ + "static/EXPERT_COORDINATION-9f2e1b91e5b0db08991e64128d0a9957.png";